var exports = {
  "k": "x28a7bf27--da6948--container",
};

module.exports = exports;
